import { render } from "./UnauthorizedRegisterOnEventForm.vue?vue&type=template&id=f700ef54"
import script from "./UnauthorizedRegisterOnEventForm.vue?vue&type=script&lang=js"
export * from "./UnauthorizedRegisterOnEventForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__